import { useAuth } from '@/providers/AuthProvider';
import { Avatar, Divider, Dropdown, Menu } from '@arco-design/web-react';
import { IconPoweroff, IconSettings } from '@arco-design/web-react/icon';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export function UserDropdown() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const droplist = (
    <Menu
      onClickMenuItem={(key) => {
        if (key === 'logout') {
          logout();
        } else if (key === 'setting') {
          navigate('/account/setting');
        } else {
          // Message.info(`You clicked ${key}`);
        }
      }}
    >
      <Menu.Item key="setting">
        <IconSettings />
        用户设置
      </Menu.Item>
      <Divider style={{ margin: '4px 0' }} />
      <Menu.Item key="logout">
        <IconPoweroff />
        退出
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown droplist={droplist} position="br">
      <Avatar size={32} style={{ cursor: 'pointer' }}>
        <img
          alt="avatar"
          src={
            'https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60'
          }
        />
      </Avatar>
    </Dropdown>
  );
}
